<template>
    <el-select
            size="large"
            class="select-primary"
            v-model="newValue"
            value-key="_id"
            filterable
            remote
            reserve-keyword
            :placeholder="$t('Type for search...')"
            :multiple="multiple"
            :remote-method="throttledFetch"
            :loading="loading">
        <el-option
                v-for="item in options"
                :key="item._id"
                :label="labelFormat(item)"
                :value="item">
        </el-option>
    </el-select>
</template>

<script>
    import User from '@/store/models/User'
    import Team from '@/store/models/Team'
    import { Select, Option } from 'element-ui'
    import isEmpty from 'lodash/isEmpty'
    import throttle from 'lodash/throttle'
    import debounce from 'lodash/debounce'
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'TaskInputPicker',
        components: {
            [Select.name]: Select,
            [Option.name]: Option
        },
        props: {
            label: {
                type: String
            },
            value: {
                required: true
            },
            dataType: {
                type: String,
                required: true,
                validator: value => ['user', 'team'].indexOf(value) !== -1
            },
            multiple: {
                type: Boolean,
                default: false
            },
            filter: {
                type: Function
            },
            prefetch: {
                type: Boolean,
                default: true
            },
            task: {
                types: Object
            }
        },
        data () {
            return {
                newValue: [],
                loading: false,
                options: [],
                throttledFetch: throttle(this.remoteMethod.bind(this), 1000),
                debouncedPrefetch: debounce(this.prefetchMethod.bind(this), 1000)
            }
        },

        async mounted () {
            this.handleValueChange()

            if (this.prefetch) {
                await this.debouncedPrefetch()
            }
        },
        computed: {
            ...mapState('user/tasks', {
                resultUsers: state => state.users,
                userStatus: state => state.userStatus,
                resultTeams: state => state.teams,
                teamStatus: state => state.teamStatus
            })
        },
        methods: {
            ...mapActions('user/tasks', ['getUsers', 'getTeams']),
            handleValueChange (){
                if (!isEmpty(this.value)) {
                    this.newValue = this.value
                }
            },
            async apiCall (params) {
                const name = this.dataType.toLowerCase()

                if (name === 'user') {
                    await this.getUsers({ l: params.l, search: params.search })

                    const items = this.resultUsers.items
                    items.push(this.value)
                    if (this.filter) {
                        return items.filter(this.filter)
                    }
                    return items

                } else if (name === 'team') {
                    await this.getTeams({ l: params.l, search: params.search })

                    const items = this.resultTeams.items
                    items.push(this.value)
                    if (this.filter) {
                        return items.filter(this.filter)
                    }
                    return items
                }

                return []
            },
            labelFormat: function (item) {
                switch (this.dataType.toLowerCase()) {
                    case 'user':
                        return this.$options.filters.formatDisplayName(item)
                    case 'team':
                        return item.title
                    default:
                        return item.label
                }
            },
            async prefetchMethod () {
                this.loading = true
                this.options = []
                this.options = await this.apiCall({ l: 10 })
                this.loading = false
            },
            async remoteMethod (query) {
                if (query !== '') {
                    this.loading = true
                    this.options = []
                    this.options = await this.apiCall({search: query})
                    this.loading = false
                } else {
                    this.options = []
                }
            }
        },
        watch: {
            newValue () {
                this.$emit('input', this.newValue)
            },
            value () {
                this.handleValueChange()
            },
            dataType () {
                this.newValue = ''
                this.$emit('input', this.newValue)
                this.remoteMethod()
            }
        }
    }
</script>
